import { render, staticRenderFns } from "./GridResize.vue?vue&type=template&id=f336fa92&"
import script from "./GridResize.vue?vue&type=script&lang=ts&"
export * from "./GridResize.vue?vue&type=script&lang=ts&"
import style0 from "./GridResize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports